import { Text, View } from 'react-native';
import { createFileRoute } from '@tanstack/react-router';
import { LegalScreen, H2, P, Bullet } from '@/components/LegalScreen';

export const Route = createFileRoute('/terms')({
  component: TermsScreen,
});

function B({ children }: { children: React.ReactNode }) {
  return <Text style={{ fontWeight: '600', color: '#18181B' }}>{children}</Text>;
}

function TermsScreen() {
  return (
    <LegalScreen title="Terms of Service" effective="15 May 2026">
      <P>
        These Terms govern your use of halvn. By creating an account or using the service you
        agree to these Terms.
      </P>

      <H2>1. halvn is not medical advice</H2>
      <P>
        <B>halvn is an estimation tool, not medical advice.</B> Dose recommendations,
        active-amount estimates, and decay curves are derived from a one-compartment
        pharmacokinetic model using population-average half-life parameters. They do not
        reflect your individual biology and are not a substitute for clinical judgement.
      </P>
      <P>
        halvn is intended for people already under the supervision of a prescribing clinician.{' '}
        <B>Do not adjust your dose or schedule based on what halvn displays without consulting
        your prescriber.</B>
      </P>

      <H2>2. Eligibility</H2>
      <P>You must be 18 or older and using the service where lawful in your jurisdiction.</P>

      <H2>3. Your account</H2>
      <P>
        Authentication is via one-time email codes. Keep that email secure. You're responsible
        for activity on your account.
      </P>

      <H2>4. Your data</H2>
      <P>
        You own your data. You grant us a limited licence to store, transmit, display, and
        process it to provide the service. We don't sell it, advertise on it, or train AI
        models with it.
      </P>

      <H2>5. Acceptable use</H2>
      <Bullet>Use halvn lawfully in your jurisdiction.</Bullet>
      <Bullet>Don't reverse-engineer, scrape, or interfere with the service.</Bullet>
      <Bullet>Don't misrepresent your identity.</Bullet>
      <Bullet>Don't use halvn to give medical advice to others.</Bullet>
      <Bullet>No clinical or research deployment without a written agreement.</Bullet>

      <H2>6. Service availability</H2>
      <P>
        halvn is provided as-is. We don't guarantee uninterrupted service or accuracy to any
        specific tolerance.
      </P>

      <H2>7. Pricing</H2>
      <P>Free during early access. 30 days' notice before any paid tier change.</P>

      <H2>8. Intellectual property</H2>
      <P>The halvn brand, copy, design, and code are owned by the halvn project.</P>

      <H2>9. Disclaimer of warranties</H2>
      <P>
        To the maximum extent permitted by law, halvn is provided without warranties of any
        kind. Nothing here excludes consumer guarantees under the Australian Consumer Law.
      </P>

      <H2>10. Limitation of liability</H2>
      <P>
        To the maximum extent permitted by law, we are not liable for indirect, incidental, or
        consequential damages including health outcomes. Where liability cannot be excluded,
        our aggregate liability is limited to re-supply of the service or refund of fees paid
        in the prior 12 months.
      </P>

      <H2>11. Indemnity</H2>
      <P>You indemnify us against claims arising from misuse or breach of these Terms.</P>

      <H2>12. Termination</H2>
      <P>
        Close your account anytime from Profile. We can suspend or terminate accounts that
        breach these Terms.
      </P>

      <H2>13. Changes</H2>
      <P>Material changes communicated with 14 days' notice.</P>

      <H2>14. Governing law</H2>
      <P>New South Wales, Australia. Non-exclusive jurisdiction.</P>

      <H2>15. Contact</H2>
      <P>hello@halvn.app · legal@halvn.app</P>

      <View className="h-8" />
    </LegalScreen>
  );
}
